import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'

import {HashRouter as Router, Route, Switch, browserHistory} from 'react-router-dom'
import {Http, getEnvironment} from 'common'
import {Messenger, CsrfToken, EmailToken, Support} from 'common/components'

import SessionCreate from './pages/SessionCreate'
import SignUpPhoneConfirm from './pages/SessionCreate/Confirm'
import PasswordRecovery from './pages/PasswordRecovery'
import PasswordRecoveryEdit from './pages/PasswordRecovery/Edit'
import PasswordRecoveryPhoneConfirm from './pages/PasswordRecovery/Confirm'


export default class App extends React.Component {
    static childContextTypes = {
        environment: PropTypes.object
    }

    state = {
    }

    getChildContext() {
        const {csrfToken, captchaSitekey} = this.state
        return {
            environment: {csrfToken, captchaSitekey}
        }
    }

    componentWillMount() {
        Http.GET('api/session', data => {
            if (data.username) {
                const {WELCOME_URL} = getEnvironment()
                window.location = WELCOME_URL
            }
        })
    }

    handleTokenChange = (csrfToken) =>
        this.setState({csrfToken})

    handleCaptchaChange = (captchaSitekey) =>
        this.setState({captchaSitekey})


    render() {
        const {hidden} = this.props

        if (hidden) {
            return (
                <div></div>
            )
        }

        return (
            <Router basename="/" history={browserHistory}>
                <div className="content">
                    <Messenger>
                        <CsrfToken onChange={this.handleTokenChange} />
                        <EmailToken type='Register' path='api/users/signup/confirm' />

                        <Switch>
                            <Route path='/passwordrecovery/:login/confirm' component={PasswordRecoveryPhoneConfirm} />
                            <Route path='/passwordrecovery/:login/edit' component={PasswordRecoveryEdit} />
                            <Route path='/passwordrecovery' component={PasswordRecovery} />
                            <Route path='/signup/:login/confirm' component={SignUpPhoneConfirm} />
                            <Route path='/' component={SessionCreate} />
                        </Switch>
                        <Support />
                    </Messenger>
                </div>
            </Router>
        )
    }
}
